import ConfigRoutes from "../../config/Routes"
import DashboardIndex from "../controllers/DashboardIndex";
import PermissionsIndex from "../controllers/PermissionsIndex";
import AdminsIndex from "../controllers/AdminsIndex";
import AdminsEdit from "../controllers/AdminsEdit";
import AdminsNew from "../controllers/AdminsNew";
import RoleIndex from "../controllers/RoleIndex";
import RoleEdit from "../controllers/RoleEdit";
import ProfileIndex from "../controllers/ProfileIndex";
import EligibilityRequestsIndex from "../controllers/EligibilityRequestsIndex";
import InvoiceIndex from "../controllers/InvoiceIndex";
import InvoiceForm from "../controllers/InvoiceForm";
import SharedFileForm from "../controllers/SharedFileForm";
import DownloadablesForm from "../controllers/DownloadablesForm";
import ProductNew from "../controllers/ProductNew";
import ProductIndex from "../controllers/ProductIndex";
import ProductEdit from "../controllers/ProductEdit";
import OptionIndex from "../controllers/OptionIndex";
import BackofficeEntityProductsIndex from "../controllers/BackofficeEntityProductsIndex";
import BackofficeEntityOptionsIndex from "../controllers/BackofficeEntityOptionsIndex";
import BackofficeOrdersShow from "../controllers/BackofficeOrdersShow";
import BackofficeTasksShow from "../controllers/BackofficeTasksShow";
import BackofficeTasksIndex from "../controllers/BackofficeTasksIndex";
import BackofficeOrdersIndex from "../controllers/BackofficeOrdersIndex";
import BackofficeOrdersEdit from "../controllers/BackofficeOrdersEdit";
import BackofficeStudyRequestsIndex from "../controllers/BackofficeStudyRequestsIndex";
import BackofficeWorkflowsIndex from "../controllers/BackofficeWorkflowsIndex";
import BackofficeWorkflowsShow from "../controllers/BackofficeWorkflowsShow";
import BackofficeStepsShow from "../controllers/BackofficeStepsShow";
import BackofficeStepsNew from "../controllers/BackofficeStepsNew";
import BackofficeCustomFieldsForm from "../controllers/BackofficeCustomFieldsForm";
import BackofficeServicesIndex from "../controllers/BackofficeServicesIndex.js";
import BackofficeEligibilitiesIndex from "../controllers/BackofficeEligibilitiesIndex";
import BackofficeEligibilitiesShow from "../controllers/BackofficeEligibilitiesShow";
import BackofficeOrdersNew from "../controllers/BackofficeOrdersNew";
import BackofficeOperationsIndex from "../controllers/BackofficeOperationsIndex";
import BackofficeEntitiesForm from "../controllers/BackofficeEntitiesForm.js";
import BackofficeEntitiesIndex from "../controllers/BackofficeEntitiesIndex.js";
import BackofficeOrdersPdfIndex from "../controllers/BackofficeOrdersPdfIndex.js";
import BackofficeNotificationsIndex from "../controllers/BackofficeNotificationsIndex.js";
import BackofficeProductsForm from "../controllers/BackofficeProductsForm.js";
import BackofficeWorkflowsEditNotifications from "../controllers/BackofficeWorkflowsEditNotifications.js";
import BackofficeIncidentCategoriesForm from "../controllers/BackofficeIncidentCategoriesForm.js";
import BackofficeIncidentCriticitiesForm from "../controllers/BackofficeIncidentCriticitiesForm.js";
import BackofficeServicesForm from "../controllers/BackofficeServicesForm.js";
import BackofficeCustomersForm from "../controllers/BackofficeCustomersForm.js";
import BackofficeStudyRequestsShow from "../controllers/BackofficeStudyRequestsShow.js";
import BackofficeStudyRequestsEdit from "../controllers/BackofficeStudyRequestsEdit.js";
import BackofficeInvoiceManagementIndex from "../controllers/BackofficeInvoiceManagementIndex";
import BackofficeMondayImportsIndex from "../controllers/BackofficeMondayImportsIndex";
import BackofficeMondayImportsStats from "../controllers/BackofficeMondayImportsStats";
import BackofficeResiliationRequestsIndex from "../controllers/BackofficeResiliationRequestsIndex";
import BackofficeResiliationRequestsHistory from "../controllers/BackofficeResiliationRequestsHistory";
import BackofficeUpgradeRequestsIndex from "../controllers/BackofficeUpgradeRequestsIndex";
import BackofficeMoesIndex from "../controllers/BackofficeMoesIndex";
import BackofficeMoesForm from "../controllers/BackofficeMoesForm";
import BackofficeProjectsIndex from "../controllers/BackofficeProjectsIndex";
import BackofficeProjectsShow from "../controllers/BackofficeProjectsShow";
import BackofficeSatisfactionFormsIndex from "../controllers/BackofficeSatisfactionFormsIndex";
import BackofficeSatisfactionFormsStats from "../controllers/BackofficeSatisfactionFormsStats";
import BackofficeSatisfactionFormTemplatesShow from "../controllers/BackofficeSatisfactionFormTemplatesShow";
import BackofficeSatisfactionFormFieldsForm from "../controllers/BackofficeSatisfactionFormFieldsForm";
import BackofficeAllCustomersIndex from "../controllers/BackofficeAllCustomersIndex";
import BackofficeStudyRequestImportsIndex from "../controllers/BackofficeStudyRequestImportsIndex";
import BackofficeStudyRequestImportsShow from "../controllers/BackofficeStudyRequestImportsShow";
import BackofficeStudyRequestImportsStats from "../controllers/BackofficeStudyRequestImportsStats";
import BackofficeMenusIndex from "../controllers/BackofficeMenusIndex";
import BackofficeMenusForm from "../controllers/BackofficeMenusForm";
import BackofficeDocumentationsDatabaseMcd from "../controllers/BackofficeDocumentationsDatabaseMcd";
import BackofficeApiLogsIndex from "../controllers/BackofficeApiLogsIndex";
import BackofficeExtendedEligibilityZonesIndex from "../controllers/BackofficeExtendedEligibilityZonesIndex";
import BackofficeMoePlanningsIndex from "../controllers/BackofficeMoePlanningsIndex";
import BackofficeMoeOrdersShow from "../controllers/BackofficeMoeOrdersShow";
import BackofficeMoeOrdersIndex from "../controllers/BackofficeMoeOrdersIndex";

export default class Routes extends ConfigRoutes{

    static routes = {
        //"DashboardIndex": DashboardIndex,
        "BackofficeBackofficeDashboardTestMarkers": DashboardIndex,
        "BackofficePermissionsIndex": PermissionsIndex,
        "BackofficeAdminsIndex": AdminsIndex,
        "BackofficeAdminsEdit": AdminsEdit,
        "BackofficeAdminsUpdate": AdminsEdit,
        "BackofficeAdminsNew": AdminsNew,
        "BackofficeAdminsCreate": AdminsNew,
        "BackofficeRolesIndex": RoleIndex,
        "BackofficeRolesEdit": RoleEdit,
        "BackofficeRolesNew": RoleEdit,
        "BackofficeRolesUpdate": RoleEdit,
        "BackofficeRolesCreate": RoleEdit,
        "BackofficeProfileIndex": ProfileIndex,
        // Eligibility Requests
        "BackofficeEligibilityRequestsIndex": EligibilityRequestsIndex,
        "BackofficeEligibilityRequestsFtto": EligibilityRequestsIndex,
        "BackofficeEligibilityRequestsDas": EligibilityRequestsIndex,
        "BackofficeEligibilityRequestsFon": EligibilityRequestsIndex,
        // Invoices
        "BackofficeInvoicesIndex": InvoiceIndex,
        "BackofficeInvoicesEdit": InvoiceForm,
        "BackofficeInvoicesNew": InvoiceForm,
        "BackofficeInvoicesUpdate": InvoiceForm,
        "BackofficeInvoicesCreate": InvoiceForm,
        // Downloadables
        "BackofficeDownloadablesNew": DownloadablesForm,
        "BackofficeDownloadablesEdit": DownloadablesForm,
        "BackofficeDownloadablesUpdate": DownloadablesForm,
        "BackofficeDownloadablesCreate": DownloadablesForm,
        // Products
        "BackofficeProductsNew": BackofficeProductsForm,
        "BackofficeProductsEdit": BackofficeProductsForm,
        "BackofficeProductsIndex": ProductIndex,
        // Options
        "BackofficeOptionsIndex": OptionIndex,
        "BackofficeOptionsEdit": OptionIndex,
        // Entity Products
        "BackofficeEntityProductsIndex": BackofficeEntityProductsIndex,
        // Entity Options
        "BackofficeEntityOptionsIndex": BackofficeEntityOptionsIndex,
        // BO Orders
        "BackofficeOrdersShow": BackofficeOrdersShow,
        "BackofficeOrdersIndex": BackofficeOrdersIndex,
        "BackofficeOrdersNew": BackofficeOrdersNew,
    "BackofficeOrdersEdit": BackofficeOrdersEdit,
    "BackofficeOrdersUpdate": BackofficeOrdersEdit,
        // BO Tasks
        "BackofficeTasksShow": BackofficeTasksShow,
        "BackofficeTasksOrderTasks": BackofficeTasksIndex,
        "BackofficeTasksStudyRequestsTasks": BackofficeTasksIndex,
        "BackofficeTasksClosedTasks": BackofficeTasksIndex,
        // BO shared files (like invoices)
        "BackofficeSharedFilesNew": SharedFileForm,
        "BackofficeSharedFilesEdit": SharedFileForm,
        "BackofficeSharedFilesUpdate": SharedFileForm,
        "BackofficeSharedFilesCreate": SharedFileForm,

        // BO Customers
        "BackofficeCustomersNew": BackofficeCustomersForm,
        "BackofficeCustomersEdit": BackofficeCustomersForm,

        // Study Requests
        "BackofficeStudyRequestsIndex": BackofficeStudyRequestsIndex,
        "BackofficeStudyRequestsShow": BackofficeStudyRequestsShow,
    "BackofficeStudyRequestsEdit": BackofficeStudyRequestsEdit,
    "BackofficeStudyRequestsUpdate": BackofficeStudyRequestsEdit,

        // Workflows
        "BackofficeWorkflowsIndex": BackofficeWorkflowsIndex,
        "BackofficeWorkflowsShow": BackofficeWorkflowsShow,
        "BackofficeStepsShow": BackofficeStepsShow,
        "BackofficeStepsNew": BackofficeStepsNew,
        "BackofficeCustomFieldsEdit": BackofficeCustomFieldsForm,
        "BackofficeCustomFieldsNew": BackofficeCustomFieldsForm,

        // Services
        "BackofficeServicesIndex": BackofficeServicesIndex,
        "BackofficeServicesEdit": BackofficeServicesForm,
        "BackofficeServicesNew": BackofficeServicesForm,

        // Entities
        "BackofficeEntitiesIndex": BackofficeEntitiesIndex,
        "BackofficeEntitiesNew": BackofficeEntitiesForm,
        "BackofficeEntitiesEdit": BackofficeEntitiesForm,

        // Eligibilities
        "BackofficeEligibilitiesIndex": BackofficeEligibilitiesIndex,
        "BackofficeEligibilitiesShow": BackofficeEligibilitiesShow,

        // Operations
        "BackofficeOperationsIndex": BackofficeOperationsIndex,

        // Orders PDF
        "BackofficeOrdersPdfIndex": BackofficeOrdersPdfIndex,

        // Invoice Management
        "BackofficeInvoiceManagementIndex": BackofficeInvoiceManagementIndex,

        // Notifications
        "BackofficeNotificationsIndex": BackofficeNotificationsIndex,
        "BackofficeWorkflowsEditNotifications" : BackofficeWorkflowsEditNotifications,

        // Incidents
        "BackofficeIncidentCategoriesNew": BackofficeIncidentCategoriesForm,
        "BackofficeIncidentCategoriesEdit": BackofficeIncidentCategoriesForm,
        "BackofficeIncidentCriticitiesNew": BackofficeIncidentCriticitiesForm,
        "BackofficeIncidentCriticitiesEdit": BackofficeIncidentCriticitiesForm,

        // Monday Imports
        "BackofficeMondayImportsIndex": BackofficeMondayImportsIndex,
        "BackofficeMondayImportsStats": BackofficeMondayImportsStats,
        
        // Resiliation Requests
        "BackofficeResiliationRequestsIndex": BackofficeResiliationRequestsIndex,
        "BackofficeResiliationRequestsHistory": BackofficeResiliationRequestsHistory,
        
        // Upgrade Requests
        "BackofficeUpgradeRequestsIndex": BackofficeUpgradeRequestsIndex,
        "BackofficeUpgradeRequestsHistory": BackofficeUpgradeRequestsIndex,

        // MOEs
        "BackofficeMoesIndex": BackofficeMoesIndex,
        "BackofficeMoesEdit": BackofficeMoesForm,
        "BackofficeMoesNew": BackofficeMoesForm,

        // MOE Planning
        "BackofficeMoePlanningsIndex": BackofficeMoePlanningsIndex,

        // MOE Orders
        "BackofficeMoeOrdersIndex": BackofficeMoeOrdersIndex,
        "BackofficeMoeOrdersShow": BackofficeMoeOrdersShow,

        // Projects
        "BackofficeProjectsIndex": BackofficeProjectsIndex,
        "BackofficeProjectsNew": BackofficeProjectsIndex,
        "BackofficeProjectsEdit": BackofficeProjectsIndex,
        "BackofficeProjectsShow": BackofficeProjectsShow,

        // Satisfaction Forms
        "BackofficeSatisfactionFormsIndex": BackofficeSatisfactionFormsIndex,
        "BackofficeSatisfactionFormsStats": BackofficeSatisfactionFormsStats,

        // Satisfaction Form Templates
        "BackofficeSatisfactionFormTemplatesIndex": BackofficeSatisfactionFormTemplatesShow,
        "BackofficeSatisfactionFormTemplatesShow": BackofficeSatisfactionFormTemplatesShow,
        "BackofficeSatisfactionFormTemplatesNew": BackofficeSatisfactionFormTemplatesShow,
        "BackofficeSatisfactionFormTemplatesEdit": BackofficeSatisfactionFormTemplatesShow,
        "BackofficeSatisfactionFormFieldsNew": BackofficeSatisfactionFormFieldsForm,
        "BackofficeSatisfactionFormFieldsEdit": BackofficeSatisfactionFormFieldsForm,

        // All Customers
        "BackofficeAllCustomersIndex": BackofficeAllCustomersIndex,

        // Study Request Imports
        "BackofficeStudyRequestImportsIndex": BackofficeStudyRequestImportsIndex,
        "BackofficeStudyRequestImportsShow": BackofficeStudyRequestImportsShow,
        "BackofficeStudyRequestImportsStats": BackofficeStudyRequestImportsStats,

        // Menus
        "BackofficeMenusIndex": BackofficeMenusIndex,
        "BackofficeMenusNew": BackofficeMenusForm,
        "BackofficeMenusCreate": BackofficeMenusForm,
        "BackofficeMenusEdit": BackofficeMenusForm,
        "BackofficeMenusUpdate": BackofficeMenusForm,

        // Documentations
        "BackofficeDocumentationsDatabaseMcd": BackofficeDocumentationsDatabaseMcd,
        // API Logs
        "BackofficeApiLogsIndex": BackofficeApiLogsIndex,

        // Extended Eligibility Zones
        "BackofficeExtendedEligibilityZonesIndex": BackofficeExtendedEligibilityZonesIndex,
    };

    constructor() {
        super();
        this.routes = Object.assign(this.routes, Routes.routes);
    }
}